import { render, staticRenderFns } from "./VideoScript.vue?vue&type=template&id=5a6e080c&scoped=true"
import script from "./VideoScript.vue?vue&type=script&lang=js"
export * from "./VideoScript.vue?vue&type=script&lang=js"
import style0 from "./VideoScript.vue?vue&type=style&index=0&id=5a6e080c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6e080c",
  null
  
)

export default component.exports